import type { QueryClient } from "@tanstack/react-query";
import { createRootRouteWithContext, Outlet } from "@tanstack/react-router";
import { BrowserCompatibilityBanner } from "@/components/BrowserCompatibilityBanner";

interface MyRouterContext {
	queryClient: QueryClient;
	userId: string | null;
	get_token: () => Promise<string | null>;
}

export const Route = createRootRouteWithContext<MyRouterContext>()({
	component: () => (
		<>
			<BrowserCompatibilityBanner />
			<Outlet />
		</>
	),
});
